import { render, staticRenderFns } from "./SaleList.vue?vue&type=template&id=b15fd1b0&"
import script from "./SaleList.vue?vue&type=script&lang=js&"
export * from "./SaleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports